import { CSSObject } from '@chakra-ui/react';
import featureDesktop from '@/assets/hyperbet/images/feature/featSportBg.png';
import featuredMb from '@/assets/hyperbet/images/feature/featSportBgMb.png';

export const FlexMiscWrapper: CSSObject = {
  pb: 2,
  pt: 0,
  gap: ['2', null, '1.5'],
  flexDirection: ['column', null, 'row'],
};
export const FlexWrapper: CSSObject = {
  h: ['280px', '215px'],
  border: '2px solid',
  borderColor: 'beta.300',
  bgImage: [`url(${featuredMb})`, `url(${featureDesktop})`],
  bgPos: 'bottom',
  bgRepeat: 'no-repeat',
  bgSize: 'cover',
  alignItems: 'center',
  justifyContent: 'center',
  pos: 'relative',
  mb: ['2', null, '4'],
  mt: ['2', null, '4'],
  pt: ['1', '5'],
  pl: '0',
  flexDir: ['column', 'row'],
  borderRadius: '10px',
  boxShadow:
    '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(25, 32, 40, 1) inset, 0px 0px 0px 2px rgba(255, 255, 255, 0.15) inset',
};
export const FlexFeatureCardWrapper: CSSObject = {
  w: 'full',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};
export const FlexTeamWrapper: CSSObject = {
  flexDir: ['column', 'row'],
  gap: ['1', '3'],
  maxW: '450px',
  mb: ['2', '3'],
  mt: '2',
};
export const FlexTextWrapper: CSSObject = {
  width: ['unset', '60%'],
};
export const TextVS: CSSObject = {
  bg: 'transparent',
  color: 'gamma.300',
  fontSize: 'md',
  fontWeight: 'normal',
  borderRadius: 'md',
  border: '2px solid',
  borderColor: 'gamma.300',
  fontFamily: 'Staatliches',
  boxShadow: 'unset',
};
export const TextMisc: CSSObject = {
  bg: 'alpha.800',
  boxShadow:
    '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
  borderRadius: 'md',
  color: 'gamma.300',
  fontSize: '2xs',
  fontFamily: 'body',
  fontWeight: 'bold',
  borderBottom: 'none',
  span: { display: 'inline-block', color: 'whiteAlpha.300', mx: '1' },
};
export const TextTeam: CSSObject = {
  color: 'white',
  fontSize: 'lg',
  textTransform: 'capitalize',
  fontWeight: 'bold',
  fontFamily: 'accent',
  lineHeight: 'normal',
};
export const BoxHeadingWrapper: CSSObject = {
  fontFamily: 'Staatliches',
  fontSize: '3xl',
  fontWeight: 'normal',
  textShadow: '0px 4px 6px rgba(0, 0, 0, 0.20)',
  color: 'alpha.600',
};
export const puntButtonProps: CSSObject = {
  variant: 'odds',
  pt: '1',
  borderRadius: 'md',
  fontSize: 'xs',
  color: 'blackAlpha.800',
  fontFamily: 'accent',
  fontWeight: 'bold',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.5)',
};
export const HeadingSlogan: CSSObject = {
  color: 'beta.300',
  fontFamily: 'accent',
  fontWeight: 'bold',
  fontSize: ['24px', null, '27px'],
  textShadow: '0px 0px 9px rgba(173, 241, 6, 0.7)',
  textTransform: 'capitalize',
};
